module.exports = __webpack_public_path__ + "img/avatar0.6eb8e681.png";